export const MenuIdAddons = 'ADDONS' as const;
